var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTranslation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.435 10.535L8.165 9.28L8.18 9.265C9.05 8.295 9.67 7.18 10.035 6H11.5V5H8V4H7V5H3.5V5.995H9.085C8.75 6.96 8.22 7.875 7.5 8.675C7.035 8.16 6.65 7.595 6.345 7H5.345C5.71 7.815 6.21 8.585 6.835 9.28L4.29 11.79L5 12.5L7.5 10L9.055 11.555L9.435 10.535ZM12.25 8H11.25L9 14H10L10.56 12.5H12.935L13.5 14H14.5L12.25 8ZM10.94 11.5L11.75 9.335L12.56 11.5H10.94Z",
    fill: "#A4A4A4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslation);
export default __webpack_public_path__ + "static/media/translation.74d5840077c162e54136759a228f0ba1.svg";
export { ForwardRef as ReactComponent };